import {Inject, Injectable} from '@angular/core';
import {EntitiesChannel} from "../../../commons/angular/classes/entities-channel";
import {Service} from "../../models/service.model";

@Injectable({providedIn: 'root'})
export class ServicesChanelService extends EntitiesChannel<Service> {

  constructor(@Inject('firebaseService') protected firebaseService) {
    super()
  }

  getChannelName(): String {
    return "services_changed";
  }

  getPartialChannelName(): String {
    return "services_partial_changed";
  }

  getCreateChannelName(): String {
    return "services_created";
  }

}
